// @ts-nocheck
import formatDate from "includes/formatDate";
import genRequest from "includes/request";

class CategoryObject {
	#categoryId = null;
	#companyId = null;
	#name = null;
	#categoryColor = null;
	#description = null;
	#lastChanged = null;
	#lastChangeAuthorId = null;
	#categoryType = null;
	#isFavorite = false;
	#favoritePosition = 0;

	#types = [];

	constructor(props) {
		// categoryId first: SelectionList items carry a prefixed `id`
		this.#categoryId = props.categoryId || props.id || null;
		this.#companyId = props.companyId || null;
		this.#name = props.categoryName || props.name || "";
		this.#categoryColor = props.categoryColor || null;
		this.#description = props.description || "";
		this.#isFavorite = props.isFavorite || false;
		this.#favoritePosition = props.favoritePosition || "";
		this.#categoryType = props.categoryType || "documents";
		this.#lastChanged = props.lastChanged || formatDate();
		this.#lastChangeAuthorId = props.lastChangeAuthorId || null;
		this.#types = props.types || [];
	}

	send() {
		let that = this;
		let isNew = !(this.#categoryId > 0);
		let prom = new Promise((resolve, reject) => {
			that.sendCat()
				.then((resp) => {
					if (isNew) return that.linkToCompany();
					resolve(resp);
					return resp;
				}, reject)
				.then(() => {
					resolve(that.values());
					return that.values();
				}, reject);
		});
		return prom;
	}

	duplicate(new_type) {
		let vals = this.values();
		delete vals.categoryId;
		let dup = new CategoryObject({ ...vals, categoryType: new_type });
		return dup.send();
	}

	sendCat() {
		let data = this.values();
		if (!this.#categoryId) delete data.categoryId;
		let req = genRequest(
			"categories" + (this.#categoryId ? "/" + this.#categoryId : ""),
			data,
			this.#categoryId ? "put" : "post"
		).then((resp) => {
			if (!this.#categoryId) this.#categoryId = resp.id || resp.categoryId;
		});
		return req;
	}

	linkToCompany = () =>
		genRequest(
			"categories/" + this.#categoryId + "/link-company",
			{
				companyId: this.#companyId,
			},
			"post"
		);

	categoryId(setValue) {
		if (typeof setValue !== "undefined") this.#categoryId = setValue;
		return this.#categoryId;
	}

	companyId(setValue) {
		if (typeof setValue !== "undefined") this.#companyId = setValue;
		return this.#companyId;
	}

	name(setValue) {
		if (typeof setValue !== "undefined") this.#name = setValue;
		return this.#name;
	}

	categoryColor(setValue) {
		if (typeof setValue !== "undefined") this.#categoryColor = setValue;
		return this.#categoryColor;
	}

	description(setValue) {
		if (typeof setValue !== "undefined") this.#description = setValue;
		return this.#description;
	}

	isFavorite(setValue) {
		if (typeof setValue !== "undefined") this.#isFavorite = setValue;
		return this.#isFavorite;
	}

	favoritePosition(setValue) {
		if (typeof setValue !== "undefined") this.#favoritePosition = setValue;
		return this.#favoritePosition;
	}

	lastChanged(setValue) {
		if (typeof setValue !== "undefined") this.#lastChanged = setValue;
		return this.#lastChanged;
	}

	lastChangeAuthorId(setValue) {
		if (typeof setValue !== "undefined")
			this.#lastChangeAuthorId = setValue;
		return this.#lastChangeAuthorId;
	}

	categoryType(setValue) {
		if (typeof setValue !== "undefined") this.#categoryType = setValue;
		return this.#categoryType;
	}

	setTypes(types) {
		this.#types = types;
		return this.#types;
	}

	types = () => this.#types;

	values = () => ({
		categoryId: this.#categoryId,
		companyId: this.#companyId,
		categoryName: this.#name,
		categoryColor: this.#categoryColor,
		description: this.#description,
		lastChanged: this.#lastChanged,
		lastChangeAuthorId: this.#lastChangeAuthorId,
		categoryType: this.#categoryType,
		isFavorite: this.#isFavorite,
		favoritePosition: this.#favoritePosition,
	});
}

export default CategoryObject;
